module.exports = __webpack_public_path__ + "static/media/05.f3c7561d.png";